import React, { useCallback } from 'react';
import { BaseButton, useTheme, mergeStyles } from '@fluentui/react';
import { ITenantProps } from '../ITenantProps';
import { tenantListItemStyles } from './TenantListItem.styles';

export interface ITenantListItemProps {
  readonly isCurrentOrg: boolean;
  readonly item: ITenantProps;
  readonly changeTenant: (targetTenant: ITenantProps) => void;
}

export const TenantListItem: React.FC<ITenantListItemProps> = ({ item, isCurrentOrg, changeTenant }) => {
  const theme = useTheme();
  const style = tenantListItemStyles(isCurrentOrg);
  const className = mergeStyles(style.root, { fontSize: theme.fonts.medium.fontSize });
  const { tenantId, displayName } = item;
  const handleClick = useCallback(() => {
    changeTenant?.(item);
  }, [item, changeTenant]);

  if (isCurrentOrg) {
    return (
      <li>
        <div className={className} key={tenantId} onClick={handleClick} title={displayName}>
          {displayName}
        </div>
      </li>
    );
  }

  return (
    <li>
      <BaseButton className={className} key={tenantId} onClick={handleClick} title={displayName}>
        {displayName}
      </BaseButton>
    </li>
  );
};
